import { cn } from '@/lib/utils';

export const TABLES = [
  // Lookups / config
  'world',
  'map',
  'enemy',
  'item',
  'meta_tag',
  'meta_tag_synergy',
  'pet_grade',
  'pet',
  'pet_upgrade',
  'pet_summon_config',
  'pet_summon_level',
  'pet_summon_probability',
  'character',
  'skin',
  'consumable_item',
  'upgrade_config',
  'skill',
  'wave_shop_config',
  'item_group',
  // Stage / League / Valhalla
  'stage',
  'stage_wave',
  'stage_wave_enemy',
  'league_table',
  'league_table_wave',
  'league_table_wave_enemy',
  'league_season',
  'league_reward',
  'valhalla',
  'valhalla_wave',
  'valhalla_wave_enemy',
  'valhalla_season',
  // Degen
  'degen_league',
  'degen_league_wave',
  'degen_league_wave_enemy',
  'degen_rune_pool',
  'degen_conditional_pool',
  'degen_conditional_count_prob',
  'degen_season',
  'degen_season_reward',
  // Folkvangr
  'folkvangr_boss',
  'folkvangr_attack_pattern',
  'folkvangr_boss_pattern',
  'folkvangr_grade_stat',
  'folkvangr_omen',
  'folkvangr_season',
  'folkvangr_reward',
  // Quests / misc
  'quest',
  'quest_milestone',
  'guide_quest',
  'attendance_reward',
  'event_attendance',
  'product',
  'entitlement',
  'payment_event',
  'glory_shop_item',
  'free_shop_item',
  'glory_gacha_entry',
  // Game-wide
  'game_config',
  'game_difficulty',
] as const;
export type TableName = (typeof TABLES)[number];

interface Props {
  value: TableName;
  onChange: (t: TableName) => void;
}

export function TableSidebar({ value, onChange }: Props) {
  return (
    <ul className="m-0 max-h-[calc(100vh-200px)] list-none overflow-auto p-0">
      {TABLES.map((t) => (
        <li key={t}>
          <button
            type="button"
            onClick={() => onChange(t)}
            className={cn(
              'w-full cursor-pointer border-0 px-2 py-1.5 text-left font-mono text-xs transition-colors',
              t === value
                ? 'bg-accent text-accent-foreground'
                : 'bg-transparent text-foreground hover:bg-muted'
            )}
          >
            {t}
          </button>
        </li>
      ))}
    </ul>
  );
}
